import React from "react";
import EntitatsList from "./EntitatsList/EntitatsList";
import Participa from "../../components/Participa/Participa";

import "./Entitats.css";

function Entitats() {
  return (
    <>
      <section className="entitats">
        <div className="entitats__section">
          <div className="entitats__section-text">
            <h1>Entitats</h1>
            <p>
              El casal és un espai on conflueixen moltes entitats del poble que
              creuen en l’organització popular com a forma de vida. Associacions
              culturals, col·lectius feministes, grups polítics i sindicals… el
              casal els ofereix un lloc de trobada per reunions i activitats,
              i un espai de confluència per coordinar-se i créixer dins del
              poble. Estem oberts a noves entitats que vulguin formar part de La
              Flama!
            </p>
          </div>
        </div>
        <div className="entitats__list">
          <EntitatsList />
        </div>
      </section>
      <Participa />
    </>
  );
}

export default Entitats;
